@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Colorado</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      @if (baseRules["MedicalPaymentsCoverage_Checkbox"]?.includes("show")) {
        <div class="axis-grid _mt-large">
          <div class="_ml-medium _mb-medium">
            <axis-checkbox
              [formControlName]="controls[1].formControlName"
              [heading]="controls[1].label"
            ></axis-checkbox>
          </div>
        </div>
      }
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Colorado</h2>
  @if (baseRules?.RejectMedicalPaymentsCoverage_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ controls[0]?.option[0]?.label }}
      </label>
    </div>
  }
  @if (baseRules?.Accept_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ controls[0]?.option[2]?.label }}
      </label>
    </div>
  }
}
